import { Chip as ChipMui } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TreeItemWrapper = styled('div')(() => ({
  display: 'flex',
  gap: 6,
  alignItems: 'center',
  '& > *:first-child': {
    flex: '1 1 100%',
  },
}));

export const Chip = styled(ChipMui)(() => ({
  border: 0,
}));
